import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';

/**
 * Error fallback component to show when a route errors out
 */
function ErrorFallback({ error, resetErrorBoundary }) {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
    resetErrorBoundary();
  };

  return (
    <Paper
      sx={{
        p: 4,
        m: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        maxWidth: 600,
        mx: 'auto',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Something went wrong!
      </Typography>
      
      <Typography variant="body1" color="error" gutterBottom paragraph>
        The application encountered an error in this page.
      </Typography>
      
      <Box sx={{ bgcolor: 'grey.100', p: 2, borderRadius: 1, mb: 2, maxWidth: '100%', overflow: 'auto' }}>
        <Typography variant="body2" component="pre" sx={{ fontFamily: 'monospace' }}>
          {error.message}
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button variant="contained" color="primary" onClick={resetErrorBoundary}>
          Try Again
        </Button>
        <Button variant="outlined" onClick={handleGoHome}>
          Go to Home
        </Button>
      </Box>
    </Paper>
  );
}

/**
 * Route error boundary component
 * Wraps route components to catch errors and show a fallback UI
 */
export default function RouteErrorBoundary({ children }) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {children}
    </ErrorBoundary>
  );
}